const translations = {
  'waiting_payment': 'Aguardando pagamento do PIX',
  'paid': 'PIX recebido, processando reembolso',
  'refunded': 'Reembolsado',
  'pending_manual_refund': 'Reembolso em processamento',
  'failed': 'Não realizado',
  'expired': 'Expirado'
}

const colors = {
  'waiting_payment': 'warning',
  'paid': 'info',
  'refunded': 'success',
  'pending_manual_refund': 'warning',
  'failed': 'danger',
  'expired': 'secondary'
}

export {translations, colors}
